import api from "./api";

export const getAnalyticsCenterData = async () => {
    const [
        shipmentsRes,
        ordersRes,
        iotRes,
        blockchainRes,
        usersRes,
    ] = await Promise.allSettled([
        api.get("/Shipment/all"),
        api.get("/orders/active"),
        api.get("/IoTDevice"),
        api.get("/BlockchainLog"),
        api.get("/Admin/users"),
    ]);

    const shipments =
        shipmentsRes.status === "fulfilled" && Array.isArray(shipmentsRes.value.data)
            ? shipmentsRes.value.data
            : [];

    const orders =
        ordersRes.status === "fulfilled" && Array.isArray(ordersRes.value.data)
            ? ordersRes.value.data
            : [];

    const devices =
        iotRes.status === "fulfilled" && Array.isArray(iotRes.value.data)
            ? iotRes.value.data
            : [];

    const blockchainLogs =
        blockchainRes.status === "fulfilled" && Array.isArray(blockchainRes.value.data)
            ? blockchainRes.value.data
            : [];

    const users =
        usersRes.status === "fulfilled" && Array.isArray(usersRes.value.data)
            ? usersRes.value.data
            : [];

    const onlineDevices = devices.filter((d) => {
        if (!d.lastUpdated) return false;
        return Date.now() - new Date(d.lastUpdated).getTime() < 2 * 60 * 1000;
    }).length;

    return {
        revenue: 0,
        orders: orders.length,
        shipments: shipments.length,
        iotDevices: devices.length,
        onlineDevices,
        blockchainEvents: blockchainLogs.length,
        users: users.length,
        averageTrustScore: 94,
        aiRisk: 6,
        revenueTrend: [
            { name: "Mon", value: 120 },
            { name: "Tue", value: 180 },
            { name: "Wed", value: 160 },
            { name: "Thu", value: 240 },
            { name: "Fri", value: 310 },
        ],
        ordersTrend: [
            { name: "Mon", value: 4 },
            { name: "Tue", value: 7 },
            { name: "Wed", value: 5 },
            { name: "Thu", value: 9 },
            { name: "Fri", value: 12 },
        ],
        shipmentStatus: [
            { name: "Active", value: shipments.length },
            { name: "Delivered", value: 0 },
            { name: "Delayed", value: 0 },
        ],
        trustScoreData: [
            { name: "High", value: 80 },
            { name: "Medium", value: 15 },
            { name: "Low", value: 5 },
        ],
    };
};

export default {
    getAnalyticsCenterData,
};